import { useEffect } from 'react'

import './Toast.css'

interface ToastProps {
  message: string
  onClose: () => void
  duration?: number
}

export default function Toast({
  message,
  onClose,
  duration = 3000
}: ToastProps) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose()
    }, duration)
    return () => {
      clearTimeout(timer)
    }
  }, [onClose, duration])

  return (
    <div className="toast" role="status">
      <span>{message}</span>
      <button
        type="button"
        onClick={onClose}
        className="toast-close icon icon-cross"
      />
    </div>
  )
}
